"use client";

import React from 'react';
import IntentModal from '@components/molecules/IntentModal';
import { useAppSelector } from '@lib/redux/hooks';
import { BuyingIntentData } from '@services/globalIntentService';
import { PageType } from '@constants/pageTypes';

interface GlobalIntentModalProps {
  isOpen: boolean;
  onClose: () => void;
  buyingIntent: BuyingIntentData | null;
  mmvDetails?: any;
  cityName: string;
  pageType?: PageType | null;
  loginType?: string | null;
}

const GlobalIntentModal: React.FC<GlobalIntentModalProps> = ({
  isOpen,
  onClose,
  buyingIntent,
  cityName,
  mmvDetails,
  pageType,
  loginType,
}) => {
  const userProfile = useAppSelector((state) => state.profile.data);

  const handleClose = () => {
    if (typeof window !== 'undefined') {
      sessionStorage.setItem('buying_intent', 'false');
    }
    onClose();
  };

  if (!buyingIntent || !userProfile) {
    return null;
  }

  return (
    <IntentModal
      isOpen={isOpen}
      onClose={handleClose}
      buyingIntent={buyingIntent}
      cityName={cityName}
      variant="simple"
      onIntentSelect={() => {}}
      onGetQuote={handleClose}
      highPriorityCapture={false}
      mmvDetails={mmvDetails}
      pageType={pageType}
      loginType={loginType}
    />
  );
};

export default GlobalIntentModal; 